import styled from '@emotion/styled'
import { Theme } from '@mui/material'
import { Card } from 'components'

export const TableCard = styled(Card)`
  flex-grow: 4;
  display: flex;
  flex-direction: column;
  margin-bottom: 2vh;
  border-radius: 10px;
  height: 100%;
`

export const deleteModalTypography = {
  color: (theme: Theme) => theme.palette.text.secondary,
  fontSize: '22px',
  fontWeight: 'bold',
  maxWidth: '380px',
}

export const boxTableWrapper = {
  height: '100%',
  width: '98%',
  marginLeft: '1.2%',
}

export const productsBoxWrapper = {
  height: '100%',
}
